import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/Login/login'
import layout from '@/components/Layout'
import homepage from '@/components/HomePage'
import creatpage from '@/components/CreatPage'
import manuscriptlistpage from '@/components/ManuscriptListPage'
import ChangeEmail from '@/components/ChangeEmail'
import ChangePassword from '@/components/ChangePassword'
import ChangePhone from '@/components/ChangePhone'
import HelpCenterPage from '@/components/HelpCenterPage'
import MessagePage from '@/components/MessagePage'
import PageInfo from '@/components/PageInfoLayout'
import CreateInfoSuccess from '@/components/CreateInfoSuccess'
import EditPage from '@/components/EditPage'
import RealTimeInfo from '@/components/RealTimeInfo'
//没有登录跳转的页面
import PageInfoLayoutNoLogin from '@/components/PageInfoLayoutNoLogin'
Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
    },
    //没有登录跳转的页面
    {
      path: '/layoutnologin',
      name: 'layoutnologin',
      component: PageInfoLayoutNoLogin,
    },
    {
      path: '/layout',
      name: 'layout',
      redirect:homepage,
      component: layout,
      children:[
        //首页
        {
          path: '/homepage',
          name: 'homepage',
          component: homepage,
        },
        //创建稿件
        {
          path: '/creatpage',
          name: 'creatpage',
          component: creatpage,
        },
        //创建稿件成功页面
        {
          path: '/createpagesuccess',
          name: 'createpagesuccess',
          component: CreateInfoSuccess,
        },
        //稿件列表
        {
          path: '/manuscriptlistpage',
          name: 'manuscriptlistpage',
          component: manuscriptlistpage,
        },
        //稿件详情
        {
          path: '/pageInfo',
          name: 'pageInfo',
          component: PageInfo,
        },
        //稿件修改
        {
          path: '/editpage',
          name: 'editpage',
          component: EditPage,
        },
        //资讯管理
        {
          path: '/realtimeinfo',
          name: 'realtimeinfo',
          component: RealTimeInfo,
        },
        //我的消息
        {
          path: '/messagepage',
          name: 'messagepage',
          component: MessagePage,
        },
        //帮助中心
        {
          path: '/helpcenterpage',
          name: 'helpcenterpage',
          component: HelpCenterPage,
        },

        //修改密码
        {
          path: '/changepassword',
          name: 'changepassword',
          component: ChangePassword,
        },
        //修改邮箱
        {
          path: '/changeemail',
          name: 'changeemail',
          component: ChangeEmail,
        },
        //修改手机号
        {
          path: '/changephone',
          name: 'changephone',
          component: ChangePhone,
        },
      ]
    }
  ],
  // mode: "history"//干掉地址栏里边的#号键
  
})



// WEBPACK FOOTER //
// ./src/router/index.js